import { render, staticRenderFns } from "./FieldsetWrapper.vue?vue&type=template&id=2177ac17&"
import script from "./FieldsetWrapper.vue?vue&type=script&lang=js&"
export * from "./FieldsetWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports